import { render, staticRenderFns } from "./register.vue?vue&type=template&id=d3afa70c"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "../assets/css/login.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../assets/css/register.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports